// Domínio próprio de empresa (fase 5, 2026-10-17): o nginx do domínio da
// empresa (gerado pelo ops-agent a partir do Super Master → Empresa →
// Domínio) serve o site E a API no mesmo endereço. Nesses domínios o
// frontend usa a própria origem — assim o cookie de sessão do rastreamento
// e o refresh do backend são do mesmo site, mesmo em domínio fora do
// gpsdrive.com.br (cookie de terceiros é bloqueado no Safari/iPhone).
// Nos endereços da casa (site principal, Super Master, app nativo, prévias)
// nada muda: continua a URL do .env.
const MAIN_HOSTS = new Set([
  "gpsdrive.com.br",
  "www.gpsdrive.com.br",
  "admin.gpsdrive.com.br",
  "api.gpsdrive.com.br",
]);
const PREVIEW_SUFFIXES = [".edgeone.dev", ".lovable.app", ".lovableproject.com"];

export function resolveApiBase(envUrl: string): string {
  if (!envUrl || typeof window === "undefined") return envUrl;
  const { protocol, hostname, host } = window.location;
  if (protocol !== "https:" || hostname === "localhost" || MAIN_HOSTS.has(hostname)) return envUrl;
  if (PREVIEW_SUFFIXES.some((s) => hostname.endsWith(s))) return envUrl;
  return `https://${host}`;
}
